




import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class FooterItem extends Vue {}
